<div class="support-modal">
    <div class="modal-dialog support-modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">Contacter le support</h3>
            </div>

            <div class="modal-body">
                <form [formGroup]="contactSupportForm" (ngSubmit)="onSubmit()">
                    <div class="section-edit-title">
                        <h3>Envoyer un message au support :</h3>
                    </div>
                    <div class="section-edit-form">
                        <div *ngIf="submitted && field.object.errors" class="invalid-feedback">
                            <div *ngIf="field.object.errors.required">L'objet est requis</div>
                        </div>
                        <div class="form-group row">
                            <div class="section-edit-form-label col-md-6">
                                <label>Objet (<label class="text-danger mr-0">*</label>) : </label>
                            </div>
                            <div class="section-edit-form-input col-md-6">
                                <input type="text" formControlName="object"
                                    [ngClass]="{'is-invalid': submitted && field.object.errors }" />
                            </div>
                        </div>

                        <div *ngIf="submitted && field.message.errors" class="invalid-feedback">
                            <div *ngIf="field.message.errors.required">Le message est requis</div>
                        </div>
                        <div class="form-group row">
                            <div class="section-edit-form-label col-md-6">
                                <label>Message (<label class="text-danger mr-0">*</label>) : </label>
                            </div>
                            <div class="section-edit-form-input col-md-6">
                                <textarea formControlName="message" rows="4"
                                    [ngClass]="{'is-invalid': submitted && field.message.errors }" ></textarea>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="section-edit-form-label col-md-6">
                                <label>Vous souhaitez être recontacté : </label>
                            </div>
                            <div class="section-edit-form-input col-md-3">
                                <label for="tel">Par téléphone </label>
                                <input id="tel" type="radio" value="tel" class="edit-form-input-checkbox" formControlName="recontactMethode" />
                            </div>
                            <div class="section-edit-form-input col-md-3">
                                <label for="mail">Par e-mail </label>
                                <input id="mail" type="radio" value="mail" class="edit-form-input-checkbox" formControlName="recontactMethode" />
                            </div>
                        </div>

                        <div *ngIf="submitted && field.tel.errors && this.contactSupportForm.value.recontactMethode == 'tel'" class="invalid-feedback">
                            <div *ngIf="field.tel.errors.required">Le numéro de téléphone est requis</div>
                        </div>
                        <div class="form-group row" *ngIf="this.contactSupportForm.value.recontactMethode == 'tel'">
                            <div class="section-edit-form-label col-md-6">
                                <label>Numéro de téléphone (<label class="text-danger mr-0">*</label>) : </label>
                            </div>
                            <div class="section-edit-form-input col-md-6">
                                <input type="text" formControlName="tel"
                                    [ngClass]="{'is-invalid': submitted && field.tel.errors }" />
                            </div>
                        </div>

                        <div *ngIf="submitted && field.mail.errors && this.contactSupportForm.value.recontactMethode == 'mail'" class="invalid-feedback">
                            <div *ngIf="field.mail.errors.required">L'adresse mail est requise</div>
                            <div *ngIf="field.mail.errors.pattern">L'adresse mail est incorrecte</div>
                        </div>
                        <div class="form-group row" *ngIf="this.contactSupportForm.value.recontactMethode == 'mail'">
                            <div class="section-edit-form-label col-md-6">
                                <label>Adresse mail : </label>
                            </div>
                            <div class="section-edit-form-input col-md-6">
                                <input type="text" formControlName="mail"
                                    [ngClass]="{'is-invalid': submitted && field.mail.errors }" />
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="modal-footer">
                <button type="button" [disabled]="buttonDisabled" class="btn btn-giphar" (click)="closeModal()">Annuler</button>
                <button type="button" [disabled]="buttonDisabled" class="btn btn-giphar" (click)="onSubmit()">Envoyer</button>
            </div>
        </div>
    </div>
</div>
